/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeletePlaceholderInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deletePlaceholderMutationVariables = {
    input: DeletePlaceholderInput;
};
export type deletePlaceholderMutationResponse = {
    readonly deletePlaceholder: {
        readonly deletedPlaceholderId: string | null;
    } | null;
};
export type deletePlaceholderMutation = {
    readonly response: deletePlaceholderMutationResponse;
    readonly variables: deletePlaceholderMutationVariables;
};



/*
mutation deletePlaceholderMutation(
  $input: DeletePlaceholderInput!
) {
  deletePlaceholder(input: $input) {
    deletedPlaceholderId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaceholderInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePlaceholderPayload",
    "kind": "LinkedField",
    "name": "deletePlaceholder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPlaceholderId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePlaceholderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePlaceholderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deletePlaceholderMutation",
    "operationKind": "mutation",
    "text": "mutation deletePlaceholderMutation(\n  $input: DeletePlaceholderInput!\n) {\n  deletePlaceholder(input: $input) {\n    deletedPlaceholderId\n  }\n}\n"
  }
};
})();
(node as any).hash = '049af6a9bf490dca961826c02c702850';
export default node;
